import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/cart/CartDrawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ComingSoon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/Header.tsx");
